const featuredPressSlider = new Swiper('.press-slider', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  loop: true,
  centeredSlides: true,
  watchOverflow: true,
  allowTouchMove: true,
  navigation: {
    nextEl: '.featured-press .swiper-button-next',
    prevEl: '.featured-press .swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 0,
      centeredSlides: false,
      allowTouchMove: false,
    }
  }
});